/* tslint:disable */
/* eslint-disable */
/**
 * PartnerLinkApi
 * 
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  PartnerLink,
} from '../models/index';
import {
    PartnerLinkFromJSON,
    PartnerLinkToJSON,
} from '../models/index';

export interface PartnerLinkCreatePartnerLinkRequest {
    body: {
        warehouseTenantId: string;
        courierEmail: string;
        creatorId: string;
    };
}

export interface PartnerLinkUpdateStatusRequest {
    body: {
        partnerLinkId: string;
        status: string;
        updatedBy: string;
        subCourierEmail: string;
    };
}

export interface PartnerLinkSetComplianceWaiverRequest {
    body: {
        warehouseCourierId: number;
        subCourierId: number;
        /**
         * true = waive contract + KYC requirements for this partner; false = reinstate
         */
        waived: boolean;
        reason?: string;
    };
}

export interface PartnerLinkGetPartnerLinksRequest {
    tenantId: string;
    role?: string;
}

export interface PartnerLinkCheckPartnershipRequest {
    warehouseTenantId: string;
    subCourierEmail: string;
}

export interface PartnerLinkGetSpecificSubCourierCustomersRequest {
    warehouseTenantId: string;
    subCourierEmail: string;
    mailboxNumber?: number;
}

export interface PartnerLinkGetSubCourierCustomersRequest {
    warehouseTenantId: string;
    includeInactive?: boolean;
}

export interface PartnerLinkIsPartnerLinkedRequest {
    courierId: string;
}

export interface PartnerLinkCountRequest {
    where?: string;
}

export interface PartnerLinkCreateRequest {
    data?: PartnerLink;
}

export interface PartnerLinkDeleteByIdRequest {
    id: string;
}

export interface PartnerLinkExistsGetPartnerLinksIdExistsRequest {
    id: string;
}

export interface PartnerLinkExistsHeadPartnerLinksIdRequest {
    id: string;
}

export interface PartnerLinkFindRequest {
    filter?: string;
}

export interface PartnerLinkFindByIdRequest {
    id: string;
    filter?: string;
}

export interface PartnerLinkFindOneRequest {
    filter?: string;
}

export interface PartnerLinkPatchOrCreateRequest {
    data?: PartnerLink;
}

export interface PartnerLinkPrototypePatchAttributesRequest {
    id: string;
    data?: PartnerLink;
}

export interface PartnerLinkReplaceByIdPostPartnerLinksIdReplaceRequest {
    id: string;
    data?: PartnerLink;
}

export interface PartnerLinkReplaceByIdPutPartnerLinksIdRequest {
    id: string;
    data?: PartnerLink;
}

export interface PartnerLinkReplaceOrCreatePostPartnerLinksReplaceOrCreateRequest {
    data?: PartnerLink;
}

export interface PartnerLinkReplaceOrCreatePutPartnerLinksRequest {
    data?: PartnerLink;
}

export interface PartnerLinkUpdateAllRequest {
    where?: string;
    data?: PartnerLink;
}

export interface PartnerLinkUpsertWithWhereRequest {
    where?: string;
    data?: PartnerLink;
}

/**
 * 
 */
export class PartnerLinkApi extends runtime.BaseAPI {

    /**
     * Create a new partner link
     */
    async partnerLinkCreatePartnerLinkRaw(requestParameters: PartnerLinkCreatePartnerLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerLink>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling partnerLinkCreatePartnerLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PartnerLinks/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerLinkFromJSON(jsonValue));
    }

    /**
     * Create a new partner link
     */
    async partnerLinkCreatePartnerLink(requestParameters: PartnerLinkCreatePartnerLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerLink> {
        const response = await this.partnerLinkCreatePartnerLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Warehouse-only: waive or reinstate the contract + KYC requirements for one partner
     */
    async partnerLinkSetComplianceWaiverRaw(requestParameters: PartnerLinkSetComplianceWaiverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerLink>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling partnerLinkSetComplianceWaiver().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PartnerLinks/compliance-waiver`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerLinkFromJSON(jsonValue));
    }

    /**
     * Warehouse-only: waive or reinstate the contract + KYC requirements for one partner
     */
    async partnerLinkSetComplianceWaiver(requestParameters: PartnerLinkSetComplianceWaiverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerLink> {
        const response = await this.partnerLinkSetComplianceWaiverRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update partner link status
     */
    async partnerLinkUpdateStatusRaw(requestParameters: PartnerLinkUpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling partnerLinkUpdateStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PartnerLinks/update-status`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update partner link status
     */
    async partnerLinkUpdateStatus(requestParameters: PartnerLinkUpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.partnerLinkUpdateStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get partner links for a specific tenant
     */
    async partnerLinkGetPartnerLinksRaw(requestParameters: PartnerLinkGetPartnerLinksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PartnerLink>>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling partnerLinkGetPartnerLinks().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/PartnerLinks/tenant/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerLinkFromJSON));
    }

    /**
     * Get partner links for a specific tenant
     */
    async partnerLinkGetPartnerLinks(requestParameters: PartnerLinkGetPartnerLinksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PartnerLink>> {
        const response = await this.partnerLinkGetPartnerLinksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if a partner link exists and is active between two tenants
     */
    async partnerLinkCheckPartnershipRaw(requestParameters: PartnerLinkCheckPartnershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['warehouseTenantId'] == null) {
            throw new runtime.RequiredError(
                'warehouseTenantId',
                'Required parameter "warehouseTenantId" was null or undefined when calling partnerLinkCheckPartnership().'
            );
        }

        if (requestParameters['subCourierEmail'] == null) {
            throw new runtime.RequiredError(
                'subCourierEmail',
                'Required parameter "subCourierEmail" was null or undefined when calling partnerLinkCheckPartnership().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['warehouseTenantId'] != null) {
            queryParameters['warehouseTenantId'] = requestParameters['warehouseTenantId'];
        }

        if (requestParameters['subCourierEmail'] != null) {
            queryParameters['subCourierEmail'] = requestParameters['subCourierEmail'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/PartnerLinks/check-partnership`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Check if a partner link exists and is active between two tenants
     */
    async partnerLinkCheckPartnership(requestParameters: PartnerLinkCheckPartnershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.partnerLinkCheckPartnershipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if a courier is partner-linked (has any active partner link as sub-courier)
     */
    async partnerLinkIsPartnerLinkedRaw(requestParameters: PartnerLinkIsPartnerLinkedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ isPartnerLinked: boolean }>> {
        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError(
                'courierId',
                'Required parameter "courierId" was null or undefined when calling partnerLinkIsPartnerLinked().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['courierId'] != null) {
            queryParameters['courierId'] = requestParameters['courierId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/PartnerLinks/is-partner-linked`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Check if a courier is partner-linked (has any active partner link as sub-courier)
     */
    async partnerLinkIsPartnerLinked(requestParameters: PartnerLinkIsPartnerLinkedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ isPartnerLinked: boolean }> {
        const response = await this.partnerLinkIsPartnerLinkedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get customers from a specific sub-courier for a warehouse tenant
     */
    async partnerLinkGetSpecificSubCourierCustomersRaw(requestParameters: PartnerLinkGetSpecificSubCourierCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['warehouseTenantId'] == null) {
            throw new runtime.RequiredError(
                'warehouseTenantId',
                'Required parameter "warehouseTenantId" was null or undefined when calling partnerLinkGetSpecificSubCourierCustomers().'
            );
        }

        if (requestParameters['subCourierEmail'] == null) {
            throw new runtime.RequiredError(
                'subCourierEmail',
                'Required parameter "subCourierEmail" was null or undefined when calling partnerLinkGetSpecificSubCourierCustomers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['mailboxNumber'] != null) {
            queryParameters['mailboxNumber'] = requestParameters['mailboxNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/PartnerLinks/sub-courier-customers/{warehouseTenantId}/{subCourierEmail}`.replace(`{${"warehouseTenantId"}}`, encodeURIComponent(String(requestParameters['warehouseTenantId']))).replace(`{${"subCourierEmail"}}`, encodeURIComponent(String(requestParameters['subCourierEmail']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get customers from a specific sub-courier for a warehouse tenant
     */
    async partnerLinkGetSpecificSubCourierCustomers(requestParameters: PartnerLinkGetSpecificSubCourierCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.partnerLinkGetSpecificSubCourierCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get customers from all sub-couriers for a warehouse tenant
     */
    async partnerLinkGetSubCourierCustomersRaw(requestParameters: PartnerLinkGetSubCourierCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['warehouseTenantId'] == null) {
            throw new runtime.RequiredError(
                'warehouseTenantId',
                'Required parameter "warehouseTenantId" was null or undefined when calling partnerLinkGetSubCourierCustomers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeInactive'] != null) {
            queryParameters['includeInactive'] = requestParameters['includeInactive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/PartnerLinks/sub-courier-customers/{warehouseTenantId}`.replace(`{${"warehouseTenantId"}}`, encodeURIComponent(String(requestParameters['warehouseTenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get customers from all sub-couriers for a warehouse tenant
     */
    async partnerLinkGetSubCourierCustomers(requestParameters: PartnerLinkGetSubCourierCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.partnerLinkGetSubCourierCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    // Standard CRUD operations
    async partnerLinkCountRaw(requestParameters: PartnerLinkCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/PartnerLinks/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    async partnerLinkCount(requestParameters: PartnerLinkCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.partnerLinkCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async partnerLinkCreateRaw(requestParameters: PartnerLinkCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerLink>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PartnerLinks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerLinkToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerLinkFromJSON(jsonValue));
    }

    async partnerLinkCreate(requestParameters: PartnerLinkCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerLink> {
        const response = await this.partnerLinkCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async partnerLinkDeleteByIdRaw(requestParameters: PartnerLinkDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling partnerLinkDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/PartnerLinks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    async partnerLinkDeleteById(requestParameters: PartnerLinkDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.partnerLinkDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async partnerLinkFindRaw(requestParameters: PartnerLinkFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PartnerLink>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/PartnerLinks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerLinkFromJSON));
    }

    async partnerLinkFind(requestParameters: PartnerLinkFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PartnerLink>> {
        const response = await this.partnerLinkFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async partnerLinkFindByIdRaw(requestParameters: PartnerLinkFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerLink>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling partnerLinkFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/PartnerLinks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerLinkFromJSON(jsonValue));
    }

    async partnerLinkFindById(requestParameters: PartnerLinkFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerLink> {
        const response = await this.partnerLinkFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async partnerLinkFindOneRaw(requestParameters: PartnerLinkFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerLink>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/PartnerLinks/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerLinkFromJSON(jsonValue));
    }

    async partnerLinkFindOne(requestParameters: PartnerLinkFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerLink> {
        const response = await this.partnerLinkFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async partnerLinkPatchOrCreateRaw(requestParameters: PartnerLinkPatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerLink>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PartnerLinks`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerLinkToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerLinkFromJSON(jsonValue));
    }

    async partnerLinkPatchOrCreate(requestParameters: PartnerLinkPatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerLink> {
        const response = await this.partnerLinkPatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async partnerLinkPrototypePatchAttributesRaw(requestParameters: PartnerLinkPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerLink>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling partnerLinkPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PartnerLinks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerLinkToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerLinkFromJSON(jsonValue));
    }

    async partnerLinkPrototypePatchAttributes(requestParameters: PartnerLinkPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerLink> {
        const response = await this.partnerLinkPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async partnerLinkReplaceByIdPostPartnerLinksIdReplaceRaw(requestParameters: PartnerLinkReplaceByIdPostPartnerLinksIdReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerLink>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling partnerLinkReplaceByIdPostPartnerLinksIdReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PartnerLinks/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerLinkToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerLinkFromJSON(jsonValue));
    }

    async partnerLinkReplaceByIdPostPartnerLinksIdReplace(requestParameters: PartnerLinkReplaceByIdPostPartnerLinksIdReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerLink> {
        const response = await this.partnerLinkReplaceByIdPostPartnerLinksIdReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async partnerLinkReplaceByIdPutPartnerLinksIdRaw(requestParameters: PartnerLinkReplaceByIdPutPartnerLinksIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerLink>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling partnerLinkReplaceByIdPutPartnerLinksId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PartnerLinks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerLinkToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerLinkFromJSON(jsonValue));
    }

    async partnerLinkReplaceByIdPutPartnerLinksId(requestParameters: PartnerLinkReplaceByIdPutPartnerLinksIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerLink> {
        const response = await this.partnerLinkReplaceByIdPutPartnerLinksIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async partnerLinkReplaceOrCreatePostPartnerLinksReplaceOrCreateRaw(requestParameters: PartnerLinkReplaceOrCreatePostPartnerLinksReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerLink>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PartnerLinks/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerLinkToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerLinkFromJSON(jsonValue));
    }

    async partnerLinkReplaceOrCreatePostPartnerLinksReplaceOrCreate(requestParameters: PartnerLinkReplaceOrCreatePostPartnerLinksReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerLink> {
        const response = await this.partnerLinkReplaceOrCreatePostPartnerLinksReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async partnerLinkReplaceOrCreatePutPartnerLinksRaw(requestParameters: PartnerLinkReplaceOrCreatePutPartnerLinksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerLink>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PartnerLinks`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerLinkToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerLinkFromJSON(jsonValue));
    }

    async partnerLinkReplaceOrCreatePutPartnerLinks(requestParameters: PartnerLinkReplaceOrCreatePutPartnerLinksRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerLink> {
        const response = await this.partnerLinkReplaceOrCreatePutPartnerLinksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async partnerLinkUpdateAllRaw(requestParameters: PartnerLinkUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PartnerLinks/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerLinkToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    async partnerLinkUpdateAll(requestParameters: PartnerLinkUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.partnerLinkUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async partnerLinkUpsertWithWhereRaw(requestParameters: PartnerLinkUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerLink>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PartnerLinks/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerLinkToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerLinkFromJSON(jsonValue));
    }

    async partnerLinkUpsertWithWhere(requestParameters: PartnerLinkUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerLink> {
        const response = await this.partnerLinkUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
